"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordValid = void 0;
const passwordValid = (password) => {
    const passwordRegex = new RegExp(/.{6,}/);
    if (typeof password === 'string') {
        return passwordRegex.test(password);
    }
    return false;
};
exports.passwordValid = passwordValid;
